import React, { useEffect, useState } from "react";
import CommonGrid from "../../../../components/CommonGrid";
import { SpinnerBlock } from "../../../../Utils/CustomComponent";
import urls from "../../../../Utils/urls";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { gridColumns_PastPayments } from "../../../../Utils/TableColumnDefs";
import { useNavigate } from "react-router-dom";

function ReportAndDocumentBorrower() {
  const [pastPayments, setPastPayments] = useState();
  const lenderId = useSelector((state) => state.account.lenderId);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(urls.dashboard.getPastPayments(lenderId))
      .then((res) => {
        let data = res?.data?.[0] || [];
        setPastPayments(
          data?.map((item, index) => {
            if (item["Account"] !== undefined && item["Account"] !== "") {
              let _item = {};
              let account_id = item["Account"]?.split(">")[1].split("<")[0];
              _item["loan_id"] = item["Account"]
                ?.split("loan/")[1]
                .split("/")[0];
              _item["account"] = account_id;
              _item["address"] = item[""];
              _item["check_date"] = item["Check Date"];
              _item["check_no"] = item["Check Number"];
              _item["amount"] = item["Amount"];
              return _item;
            } else {
              return [];
            }
          })
        );
      })
      .catch((error) => console.error(error));
  }, [lenderId]);
  return (
    <div >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          {/* <CommonTopSectionForBorrowers /> */}
          <div
            className="mb-4 d-flex justify-content-between align-items-center"
            style={{ marginTop: "24px" }}
          >
            <h4 style={{ fontSize: "18px", fontWeight: "700" }}>
              Reports & Documents
            </h4>
            <button
              onClick={() => navigate("/run-new-report-borrower")}
              className="btn btn-primary text-white btn-outline py-3 px-4"
            >
              Run New Report
            </button>
          </div>
          <div>
            {pastPayments ? (
              <CommonGrid
                className={"past-payments favorite-report"}
                title={"Favorite Reports"}
                gridColumns={gridColumns_PastPayments}
                columnData={JSON.parse(JSON.stringify(pastPayments)).splice(
                  0,
                  pastPayments?.length - 1
                )}
                numberOfRows={2}
                tHeight="7rem"
              />
            ) : (
              <SpinnerBlock height="41vh" />
            )}
          </div>
          <div>
            {pastPayments ? (
              <CommonGrid
                className={"past-payments"}
                title={"Scheduled Reports"}
                gridColumns={gridColumns_PastPayments}
                columnData={JSON.parse(JSON.stringify(pastPayments)).splice(
                  0,
                  pastPayments?.length - 1
                )}
              />
            ) : (
              <SpinnerBlock height="41vh" />
            )}
          </div>
          <div>
            {pastPayments ? (
              <CommonGrid
                className={"past-payments delivered-report"}
                title={"Delivered Reports"}
                gridColumns={gridColumns_PastPayments}
                columnData={JSON.parse(JSON.stringify(pastPayments)).splice(
                  0,
                  pastPayments?.length - 1
                )}
              />
            ) : (
              <SpinnerBlock height="41vh" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ReportAndDocumentBorrower;
